module.exports = __webpack_public_path__ + "img/status-replay.7b6cb992.svg";